import React from 'react';
import PropTypes from 'prop-types';

import { publishFund, unpublishFund } from '../../../../services/lwadmin/fund/fund-service';
import { Link, RowContainer } from '../../shared/styles';
import { ActionColumn } from '../../companies/companies-components/styles';
import { FundNameColumn } from './styles';

export default function Fund(props) {
  const [fund, setFund] = React.useState(props.fund);

  const {
    id,
    name,
    published,
    publicUrl,
  } = fund;

  const publish = e => {
    e && e.preventDefault();

    publishFund(id).then(() => setFund({ ...fund, published: true }));
  };

  const unpublish = e => {
    e && e.preventDefault();

    unpublishFund(id).then(() => setFund({ ...fund, published: false }));
  };

  return (
    <RowContainer>
      <FundNameColumn>{name}</FundNameColumn>
      <ActionColumn>
        <Link href={published ? publicUrl : '#'}>View</Link>
        |
        <Link href={`/lwadmin/fund/${id}/edit`}>Edit</Link>
        |
        {published && <Link href="#" onClick={unpublish}>Unpublish</Link>}
        {!published && <Link href="#" onClick={publish}>Publish</Link>}
      </ActionColumn>
    </RowContainer>
  );
}

Fund.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    published: PropTypes.bool,
    publicUrl: PropTypes.string,
  }).isRequired,
};
